var map = {
	"./fivestar-logo-primary.svg": 578,
	"./fivestar-logo-secondary.svg": 4870,
	"./ingage-logo-primary.svg": 2381,
	"./ingage-logo-secondary.svg": 5833,
	"./simplesoft-logo-primary.svg": 8976,
	"./simplesoft-logo-secondary.svg": 4464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8012;